import { Directive, EmbeddedViewRef, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { AllAvailableFeatureFlags } from '../configs/all-flags.config';
import { FeatureFlagLoaderService } from '../services/feature-flag-loader.service';

// make lint rule for selecting flag from all-flags enum, the current check won't work in html
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[featureFlag]'
})
export class FeatureFlagDirective implements OnInit {
	private enabledFlag: string;
	private isHidden = true;
	private elseTemplateRef: TemplateRef<any> | null = null;
	private elseViewRef: EmbeddedViewRef<any> | null = null;

	@Input() public set featureFlag(value: string) {
		if (value) {
			this.enabledFlag = value;
			this.updateView();
		}
	}

	@Input() public set featureFlagElse(templateRef: TemplateRef<any> | null) {
		this.assertTemplate('featureFlagElse', templateRef);
		this.elseTemplateRef = templateRef;
		this.elseViewRef = null;  // clear previous view if any.
		this.updateView();
	}

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private featureFlagLoaderService: FeatureFlagLoaderService
	) { }

	public ngOnInit(): void {
		this.updateView();
	}

	private updateView(): void {
		if (this.isFeatureEnabled()) {
			if (this.isHidden) {
				this.viewContainer.clear();
				this.viewContainer.createEmbeddedView(this.templateRef);
				this.elseViewRef = null;
				this.isHidden = false;
			}
		} else {
			if (!this.elseViewRef) {
				this.viewContainer.clear();
				if (this.elseTemplateRef) {
					this.elseViewRef = this.viewContainer.createEmbeddedView(this.elseTemplateRef);
				}
				this.isHidden = true;
			}
		}
	}

	private isFeatureEnabled(): boolean {
		return (
			this.enabledFlag &&
			this.featureFlagLoaderService.isFeatureEnabled(AllAvailableFeatureFlags[this.enabledFlag])
		);
	}

	private assertTemplate(property: string, templateRef: TemplateRef<any> | null): void {
		const isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
		if (!isTemplateRefOrNull) {
			throw new Error(`${property} must be a TemplateRef, but received '${(templateRef)}'.`);
		}
	}
}
